export enum Action {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  EQUAL = 'EQUAL',
  DUPLICATE = 'DUPLICATE',
}
